import * as React from 'react';
import { cn } from '@/lib/utils';

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => {
  // Detecta si el componente ya define su propio fondo o borde
  const hasCustomBg = /\bbg-[^\s]+/.test(className);
  const hasCustomBorder =
    /\bborder-(?!\d)([^\s]+)/.test(className) ||
    /\bborder\b/.test(className);

  return (
    <div
      ref={ref}
      className={cn(
        `
        group relative overflow-hidden rounded-3xl
        supports-[backdrop-filter]:backdrop-blur-2xl
        supports-[backdrop-filter]:backdrop-saturate-150
        shadow-[0_8px_30px_rgba(0,0,0,0.08)]
        dark:shadow-[0_10px_35px_rgba(0,0,0,0.35)]
        transition-all duration-300 ease-out
        hover:-translate-y-1
        hover:shadow-[0_18px_40px_rgba(16,50,84,0.18)]
        active:scale-[0.995]
        active:translate-y-0
        `,
        !hasCustomBg &&
          'bg-white/65 dark:bg-zinc-900/55',
        !hasCustomBorder &&
          'border border-white/40 dark:border-white/10',
        className
      )}
      {...props}
    >
      {/* Reflejo superior (25% del original) */}
      <div
        className="
          pointer-events-none absolute inset-0
          bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.11),transparent_45%)]
        "
      />

      {/* Brillo lateral (25% del original) */}
      <div
        className="
          pointer-events-none absolute inset-0
          opacity-0 transition-opacity duration-500
          group-hover:opacity-100
          bg-[linear-gradient(115deg,transparent_25%,rgba(255,255,255,0.055)_50%,transparent_75%)]
        "
      />

      {/* Borde interior */}
      <div
        className="
          pointer-events-none absolute inset-0 rounded-3xl
          ring-1 ring-inset ring-white/5
        "
      />

      {props.children}
    </div>
  );
});

Card.displayName = 'Card';

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      `
      relative z-10
      p-6
      `,
      className
    )}
    {...props}
  />
));

CardContent.displayName = 'CardContent';

export { Card, CardContent };